import type {
    ITaskService,
    ITaskServiceCreatePluginParams,
    ITaskServiceTask
} from "~/api/plugins/index.js";
import { TaskServicePlugin } from "~/api/plugins/index.js";
import type { ITaskEventInput } from "~/api/types.js";
import type { PutEventsCommandOutput } from "@webiny/aws-sdk/client-eventbridge/index.js";
import { EventBridgeClient, PutEventsCommand } from "@webiny/aws-sdk/client-eventbridge/index.js";
import { WebinyError } from "@webiny/error";
import type { GenericRecord } from "@webiny/api/types.js";

class EventBridgeService implements ITaskService {
    protected readonly getTenant: () => string;
    private readonly client: EventBridgeClient;

    public constructor(params: ITaskServiceCreatePluginParams) {
        this.client = new EventBridgeClient({
            region: process.env.AWS_REGION
        });
        this.getTenant = params.getTenant;
    }

    public async send(task: ITaskServiceTask, delay: number): Promise<PutEventsCommandOutput> {
        /**
         * The ITaskEvent is what our handler expect to get.
         * Endpoint and stateMachineId are added by the step function.
         */
        const event: ITaskEventInput = {
            webinyTaskId: task.id,
            webinyTaskDefinitionId: task.definitionId,
            tenant: this.getTenant(),
            delay
        };

        const cmd = new PutEventsCommand({
            Entries: [
                {
                    Source: "webiny-api-tasks",
                    EventBusName: String(process.env.EVENT_BUS),
                    DetailType: "WebinyBackgroundTask",
                    Detail: JSON.stringify(event)
                }
            ]
        });
        try {
            const result = await this.client.send(cmd);

            return JSON.parse(JSON.stringify(result));
        } catch (ex) {
            throw new WebinyError(
                ex.message || "Could not trigger task via Event Bridge!",
                ex.code || "TRIGGER_TASK_ERROR",
                {
                    event,
                    ...(ex.data || {})
                }
            );
        }
    }

    public async fetch(): Promise<GenericRecord> {
        throw new WebinyError("Not implemented!", "NOT_IMPLEMENTED");
    }
}

export class EventBridgeEventTransportPlugin extends TaskServicePlugin {
    public override name = "task.eventBridgeEventTransport";
    public createService(params: ITaskServiceCreatePluginParams) {
        return new EventBridgeService(params);
    }
}
